export { default as ImageResize } from '@ckeditor/ckeditor5-image/src/imageresize'
